import React, { useState, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { FormikSelect } from 'components/UiKit/FormikFields';

const TownshipDirection = () => {
  const { values } = useFormikContext();
  const [captionText, setCaptionText] = useState();

  const isValueEmpty = !values.township;
  useEffect(() => {
    if (isValueEmpty) {
      setCaptionText('Township must be entered first');
    } else {
      setCaptionText(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.township]);

  return (
    <FormikSelect
      name="townshipDirection"
      id="townshipDirection"
      errorMessage={captionText}
      placeholder="Select principle meridian direction"
      items={[
        { key: 'none', value: 'None' },
        { key: 'north', value: 'North' },
        { key: 'south', value: 'South' }
      ]}
      disabled={isValueEmpty}
    />
  );
};

export default TownshipDirection;
